export default "__VITE_ASSET__75d451ea__"